import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';
import { IonicModule } from '@ionic/angular';
import { SubastaPageRoutingModule } from './subasta-routing.module';
import { SubastaPage } from './subasta.page';
import { ListaAdjudicacionesComponent } from '../modal/lista-adjudicaciones/lista-adjudicaciones.component';
import { CantidadPujaComponent } from '../modal/cantidad-puja/cantidad-puja.component';
import { SelectorPujaComponent } from '../modal/selector-puja/selector-puja.component';
import {MenuSuperiorModule} from '../menu-superior/menu-superior.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SubastaPageRoutingModule,
    MaterialModule,
    MenuSuperiorModule,
    FontAwesomeModule,
  ],
  declarations: [SubastaPage, ListaAdjudicacionesComponent, CantidadPujaComponent, SelectorPujaComponent],
  providers: [DecimalPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SubastaPageModule { }
